export const API_ALL_UNCONVERTED_LEADS_SUCCESS =
  "API_ALL_UNCONVERTED_LEADS_SUCCESS";
export const API_ALL_UNCONVERTED_LEADS_FAIL = "API_ALL_UNCONVERTED_LEADS_FAIL";
export const GET_ALL_UNCONVERTED_LEADS = "GET_ALL_UNCONVERTED_LEADS";
export const START_LOADING = "START_LOADING";
export const STOP_LOADING = "STOP_LOADING";
export const RESET_ALLUNCONVERTED_STATE = "RESET_ALLUNCONVERTED_STATE";